<template>
    <SOSlotModal :modal-title="pageSetting.modal.title" :modal-id="pageSetting.modal.id" @close="close">
        <template v-slot:modal-body>
            <div class="f-regular f-16 f-c-black p-t-16">
                Menghentikan Blast WA menyebabkan pesan yang belum dikirim menjadi gagal. Yakin ingin menghentikan?
            </div>
        </template>
        <template v-slot:modal-footer>
            <SOButton
                class="m-0 p-d-12"
                :text="'Ya, hentikan'"
                :outline-danger="true"
                :full="true"
                :disable="isFetching"
                :loading="isFetching"
                @action="hentikan"
            />
            <SOButton
                class="m-0"
                :text="'Batal'"
                :outline="true"
                :full="true"
                :disable="isFetching"
                :loading="isFetching"
                @action="close"
            />
        </template>
    </SOSlotModal>
</template>

<script>
import { moduleName } from "./../../store/state";
import { mapActions, mapGetters } from "vuex";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "ModalHentikanBlast",
    components: {
        SOSlotModal,
        SOButton,
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            detailHistory: "detailHistory",
        }),
    },
    data() {
        return {
            id: "",
            pageSetting: {
                modal: {
                    title: "Hentikan Blast WA",
                    id: "modal-hentikan-wa-blast",
                },
            },
        };
    },
    mounted() {
        $("#" + this.pageSetting.modal.id).modal("show");
        this.id = this.$route.params.id;
    },
    methods: {
        ...mapActions({
            fetchDetailHistory: `${moduleName}/fetchDetailHistory`,
            setFetching: `${moduleName}/setFetching`,

            cancelBlast: `${moduleName}/cancelBlast`,
        }),
        hentikan() {
            let form = new FormData();
            form.append("idblast", this.id);
            this.sockets.unsubscribe(`wablast.job.status.${this.id}`);
            this.cancelBlast(form)
                .then((response) => {
                    if (!response.data) {
                        this.$toast.error(response);
                    } else {
                        let { code, status, msg, data } = response.data;

                        if (status && code === 200) {
                            this.$toast.success(msg);
                            this.detailHistory.running = 0;
                            this.detailHistory.finished_at = this.$moment().format("YYYY-MM-DD HH:mm:ss");
                            this.unsubscribeIdBlast(this.id);
                            this.close();
                        } else {
                            this.$toast.error(msg);
                        }
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
        close() {
            this.$router.back();
        },
        unsubscribeIdBlast(id) {
            this.sockets.unsubscribe(this.socketKey + id);
        },
    },
};
</script>
